export const Arrow = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M7.99981 12.6665L7.64627 13.0201C7.84153 13.2153 8.15811 13.2153 8.35337 13.0201L7.99981 12.6665ZM1.68656 5.64628C1.49129 5.45102 1.17471 5.45102 0.97945 5.64629C0.78419 5.84155 0.784194 6.15813 0.979458 6.3534L1.68656 5.64628ZM15.0199 6.35339C15.2152 6.15812 15.2152 5.84154 15.0199 5.64628C14.8246 5.45102 14.508 5.45102 14.3128 5.64629L15.0199 6.35339ZM8.35336 12.3129L1.68656 5.64628L0.979458 6.3534L7.64627 13.0201L8.35336 12.3129ZM14.3128 5.64629L7.64626 12.313L8.35337 13.0201L15.0199 6.35339L14.3128 5.64629Z"
      fill="#353535"
    />
  </svg>
);
